var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"status bloc-datas"},[_c('div',{staticClass:"bloc-data full-width"},[_c('h2',[_vm._v(_vm._s(_vm.$t('status_title')))]),_vm._v(" "),_c('StatusesSelector',{attrs:{"element":_vm.cible,"target":_vm.target},on:{"change":_vm.statusChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }